export default function addToCartVariantStatus(pageProperties) {
	if (
		pageProperties &&
		pageProperties.pageType === 'product' &&
		pageProperties.pageReferer !== undefined &&
		pageProperties.variants !== undefined
	) {
		const refererSku = retrieveSku(pageProperties.pageReferer, '-p-');
		const currentVariantSkuArr = pageProperties.variants;

		const isRefererVariant = !!currentVariantSkuArr.find(
			prodSku => upperCase(prodSku) === upperCase(refererSku),
		);

		return isRefererVariant;
	}
	return false;
}

export function retrieveSku(url, separator) {
	const splitUrl = url.split(separator);
	const refererSku = splitUrl[splitUrl.length - 1].split('?')[0];
	return refererSku;
}

export function upperCase(val) {
	const stringVal = val.toString();
	return String.prototype.toUpperCase.call(stringVal);
}
